import { useMemo } from "react";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import { routerHasCustomerLoginInvitationScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import {
	buildCustomerLoginOfficeChoiceEntries,
	type OfficeChoiceEntry,
} from "@Front/Components/Layouts/Login/helpers/loginCustomerMultiCandidateRouting";
import {
	CUSTOMER_TARGET_CHOICE_SUBTITLE_DEFAULT,
	CUSTOMER_TARGET_CHOICE_SUBTITLE_INVITATION_SCOPE,
} from "@Front/Components/Layouts/Login/helpers/customerLoginNeedsChoiceMessages";
import { LoginStep } from "./loginSteps";
import type { EmailAuthCandidatesResponse } from "@Front/Api/Public/emailAuthCandidatesApi";

export function useLoginCustomerChoiceDerived(
	loginScope: CustomerLoginRouterScope,
	step: LoginStep,
	loginCandidates: EmailAuthCandidatesResponse | null,
): {
	customerOfficeChoiceEntries: OfficeChoiceEntry[];
	customerTargetChoiceSubtitle: string | undefined;
} {
	const customerOfficeChoiceEntries = useMemo(
		() => (loginCandidates ? buildCustomerLoginOfficeChoiceEntries(loginCandidates.customerCandidates) : []),
		[loginCandidates],
	);

	const customerTargetChoiceSubtitle = useMemo(() => {
		if (step !== LoginStep.CUSTOMER_TARGET_CHOICE) {
			return undefined;
		}
		return routerHasCustomerLoginInvitationScope(loginScope)
			? CUSTOMER_TARGET_CHOICE_SUBTITLE_INVITATION_SCOPE
			: CUSTOMER_TARGET_CHOICE_SUBTITLE_DEFAULT;
	}, [step, loginScope]);

	return { customerOfficeChoiceEntries, customerTargetChoiceSubtitle };
}
